












































































































import mixins from 'vue-typed-mixins';
import { PageModeMixin } from '@/main/mixins/pageMode';
import { mapActionsDvm } from '@/main/pages';
import { store } from '@/modules/servis/zakazka/store/edit';

import { SkupinaProfilSelect } from '../../components';
import JinyPrijemceSelect from '../../components/microcomponents/JinyPrijemceSelect.vue';
import ProvozovnaSelect from '../../components/microcomponents/ProvozovnaSelect.vue';
import SmluvniPartnerSelect from '../../components/microcomponents/SmluvniPartnerSelect.vue';
import SmluvniPartnerTypSelect from '../../components/microcomponents/SmluvniPartnerTypSelect.vue';
import MicroLakDruhSelect from '../../components/microcomponents/LakDruhSelect.vue';
import SDA from '../../components/microcomponents/SDA.vue';
import { EditMixin } from '../../mixins/editMixin';
import SlevaMaterialNumberInput from '../../components/microcomponents/SlevaMaterialNumberInput.vue';

export default mixins(PageModeMixin, EditMixin).extend({
	name: 'HlavniKarta',
	components: {
		MicroLakDruhSelect,
		SmluvniPartnerTypSelect,
		SlevaMaterialNumberInput,
		ProvozovnaSelect,
		SkupinaProfilSelect,
		SmluvniPartnerSelect,
		JinyPrijemceSelect,
		sda: SDA,
	},
	computed: {
		prevodMaxSuffix() {
			return ` (${this.PrevodMaxLimit ? this.PrevodMaxLimit : 0})`;
		},
		isPodilZak() {
			return this.PodilMatZak || this.PodilSlzZak;
		},
	},
	watch: {
		PodilMatInt(newVal) {
			if (newVal > 100) {
				this.PodilMatInt = 100;
			}
			this.PodilMatZak = 100 - this.PodilMatInt;
		},
		PodilSlzInt(newVal) {
			if (newVal > 100) {
				this.PodilSlzInt = 100;
			}
			this.PodilSlzZak = 100 - this.PodilSlzInt;
		},
		PodilMatZak(newVal) {
			if (newVal > 100) {
				this.PodilMatZak = 100;
			}
			this.PodilMatInt = 100 - this.PodilMatZak;
		},
		PodilSlzZak(newVal) {
			if (newVal > 100) {
				this.PodilSlzZak = 100;
			}
			this.PodilSlzInt = 100 - this.PodilSlzZak;
		},
	},
	methods: {
		...mapActionsDvm(store.actions),
		intPodilChange() {
			return this.zmenaIntPodil();
		},
	},
});
